import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonService} from './service.common';
import { Credentials} from "./bean";
import { AuthService} from './service.auth';

@Component({
	moduleId: module.id,
	selector: 'login-component',
	templateUrl: './html/login.html'
})
export class LoginComponent{
	constructor(
		private authService: AuthService,
		private commonService: CommonService,
//		private route: ActivatedRoute,
		private router: Router
	) {
	}
	async ngOnInit() {
		this.authService.logout();
		localStorage.setItem("selflogout", "true");
		localStorage.setItem("accountlogin", "false");
 

		// if(await this.authService.isAuthenticated()){
		// 	document.location.href='/site/introduction.html'
		// }
	}
    changelang(lang: string): void{
		this.commonService.changeCurrentLocaleByLanguage(lang);
	}
  
//	private credentials: Credentials = new Credentials('egypt', 'egypt');
	private credentials: Credentials = new Credentials('', '');
	keyPressed(event: KeyboardEvent) : void{
		if(event.code == 'Enter'){
//			<!-- 含中文版-->
			this.onSubmit();
		}
	}
	private showMessage: boolean;
	private onSubmit() {
		this.authService.login(this.credentials)
		.then((authToken) =>{
			if(authToken == null){
				this.showMessage = true;
//				this.message = "Login Failed";
				return;
			}
			else{
//				this.router.navigate(['https://www.hinet.net']);
//				this.router.navigate(['/site/introduction.html']);

				localStorage.setItem("accountlogin", "true");

				localStorage.setItem("selflogout", "false");
				
				this.commonService.isAuthencatedIp()
				.then((resp) => {
					if(resp){
						localStorage.setItem('showDonation', 't');
					}
					else{
						localStorage.setItem('showDonation', 'f');
					}
				
				})
						


//				window.location.assign(this.commonService.frnpath + '/site/introduction.html');
				window.location.assign(this.commonService.frnpath + '/');

				//document.location.href=this.commonService.frnpath + '/site/introduction.html'
//				this.router.navigate(['/content']);
			}
		})
		.catch((error: any) => {
//				this.authService.authenticated = false;
				this.showMessage = true;
//				this.message = "login failed";
		})
		;
			
	}


}



// WEBPACK FOOTER //
// ./src/app/login.ts